import { Subject } from 'rxjs';
import { Chart } from 'chart.js';
import { ChartModel } from '../../models/azure-dashboard-view.model';
import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportingService } from '../../services/reporting.service';
import { FileService } from '../../services/file.service';
import { NgProgress } from 'ngx-progressbar';
import { CurrentUsageTenantSummaryModel, TenantUsageSummary } from '../../models/azure-dashboard-view.model';
import { Sort } from '@angular/material/sort';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../services';
import { Perpetual, SaleLicenseKey } from '../../models/perpetual.model';
import { NgProgressService } from '../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';



declare var $: any;

@Component({
  selector: 'app-esd-detail-view',
  templateUrl: './esd-detail-view.component.html',
  styleUrls: ['./esd-detail-view.component.css']
})
export class EsdDetailViewComponent implements OnInit, OnDestroy {

  title = 'ESD Details';
  searchField = '';
  loadingFinished = false;
  loadContent = false;
  customerRef: string;
  url: string;
  orderNo: string = '';
  suffix: string = '';
  saleLicenseKey : Array<SaleLicenseKey>;
  sortedData : Array<SaleLicenseKey>;
  @Output() parentNarrowMode = new EventEmitter();
   //ngUnsubscribe
   ngUnsubscribe: Subject<void> = new Subject<void>();
  
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private calendar: NgbCalendar,
    private reportingService: ReportingService,
    private commonService: CommonService,
    private fileService: FileService,
    public ngProgress: NgProgressService
  ) { }

  sortData(sort: Sort) {
    
  }

  ngOnInit() {
    this.loadingFinished = false;
    this.parentNarrowMode.emit(true);
    this.activatedRoute.url.subscribe(value => {
      this.activatedRoute.params.subscribe(params => { 
        this.orderNo = params['orderNo'];
        if(params['suffix']){
          this.suffix = params['suffix']; 
        }
        else {
          this.suffix = '';
        }
      });
      this.showDetails();
  });
    //this.loadContent = false;
  }
  
  showDetails():void {
    this.ngProgress.start();
    this.reportingService.getSalesLicenseKey(this.orderNo, this.suffix).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((result: any) => {
      if(result && result.output){
          this.saleLicenseKey = result.output;
          this.customerRef = this.saleLicenseKey[0].out_customer_ref;
          this.sortedData = this.saleLicenseKey;
        }
        this.loadingFinished = true;
        this.ngProgress.done();
        
    },
    (error: any) => {
      console.info(error),
      this.ngProgress.done();
    });
  }

  downloadReports():void {
    this.ngProgress.start();
    //$('#btnDownload').showValidator('Usage report will be downloaded shortly', 'success');
    this.commonService.implementToast('ESD report will be downloaded shortly', 'Info');
    this.exportEsdLicenseReport();
  }

  exportEsdLicenseReport():void {
    this.ngProgress.start();
    this.reportingService.exportEsdLicencsewithStatus(this.orderNo, this.suffix).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data: any) => {
        const fileName = `ESD-${this.orderNo}-${this.suffix}.xlsx`;
        this.fileService.saveAsExcelFile(data, fileName);
        this.ngProgress.done();
        this.commonService.implementToast('ESD license report downloaded successfully', 'Success');
    },
    (error: any) => {
      console.info(error);
      this.ngProgress.done();
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.parentNarrowMode.emit(false);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }
  
  close() {
   // $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/reporting/esdreport');
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
